import { useEffect } from 'react';

interface LinkedInTrackingScriptProps {
  partnerId: string;
}

const LinkedInTrackingScript = ({ partnerId }: LinkedInTrackingScriptProps) => {
  useEffect(() => {
    // Only run in production environments
    if (import.meta.env.PROD) {
      // Create and add the first script
      const linkedInScript1 = document.createElement('script');
      linkedInScript1.type = 'text/javascript';
      linkedInScript1.innerHTML = `
        _linkedin_partner_id = "${partnerId}";
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
      `;
      document.head.appendChild(linkedInScript1);

      // Create and add the second script
      const linkedInScript2 = document.createElement('script');
      linkedInScript2.type = 'text/javascript';
      linkedInScript2.innerHTML = `
        (function(l) {
          if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
          window.lintrk.q=[]}
          var s = document.getElementsByTagName("script")[0];
          var b = document.createElement("script");
          b.type = "text/javascript";b.async = true;
          b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
          s.parentNode.insertBefore(b, s);
        })(window.lintrk);
      `;
      document.head.appendChild(linkedInScript2);

      // Add the noscript pixel
      const linkedInNoScript = document.createElement('noscript');
      const linkedInPixel = document.createElement('img');
      linkedInPixel.height = 1;
      linkedInPixel.width = 1;
      linkedInPixel.style.display = 'none';
      linkedInPixel.alt = '';
      linkedInPixel.src = `https://px.ads.linkedin.com/collect/?pid=${partnerId}&fmt=gif`;
      linkedInNoScript.appendChild(linkedInPixel);
      document.body.appendChild(linkedInNoScript);

      // Cleanup function to remove the scripts and clear globals when component unmounts
      return () => {
        if (linkedInScript1.parentNode) {
          linkedInScript1.parentNode.removeChild(linkedInScript1);
        }
        if (linkedInScript2.parentNode) {
          linkedInScript2.parentNode.removeChild(linkedInScript2);
        }
        if (linkedInNoScript.parentNode) {
          linkedInNoScript.parentNode.removeChild(linkedInNoScript);
        }
        delete (window as any).lintrk;
        delete (window as any)._linkedin_data_partner_ids;
      };
    }
  }, [partnerId]);

  return null;
};

export default LinkedInTrackingScript;
